var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.563
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.248 9.896c0 5.178-4.192 9.375-9.364 9.375C4.712 19.27.52 15.074.52 9.896S4.712.52 9.884.52c5.172 0 9.364 4.197 9.364 9.375zM16.504 16.525L24.45 24.479",
    transform: "translate(-174 -292) translate(161 279) translate(13.016 13) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.564 15.722c-.837-.4-1.746-.797-2.6-1.139V12.5s1.041-.364 1.041-2.604c.723 0 1.04-2.084.033-2.084 0-.22.797-1.361.487-2.604-.52-2.083-5.722-2.083-6.242 0-2.191-.447-.52 2.304-.52 2.604-1.04 0-.723 2.084 0 2.084 0 2.24 1.04 2.604 1.04 2.604v2.083c-.854.342-1.763.74-2.6 1.14",
    transform: "translate(-174 -292) translate(161 279) translate(13.016 13) translate(.5 .5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchJob);
export default __webpack_public_path__ + "static/media/searchJob.b3348670.svg";
export { ForwardRef as ReactComponent };